import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from './Analytics.ts';
function sendRushIncentivePopupAnalytic(type) {
    const eventData = {
        type: type,
        category: AnalyticEventCategory.Game
    };
    void CA.sendAnalyticEvent(eventData);
}
export function sendRushIncentivePopupShown() {
    sendRushIncentivePopupAnalytic(AnalyticEventType.EndGameRushIncentivePopupShown);
}
export function sendRushIncentivePopupTryRushClicked() {
    sendRushIncentivePopupAnalytic(AnalyticEventType.EndGameRushIncentivePopupTryRushClicked);
}
